<template>
  <q-page class="q-pa-md">
    <h1 class="text-h5 text-white">Insurance Technology</h1>
    <p>Our solutions include AI-driven claims processing, fraud detection, and risk assessment.</p>
  </q-page>
</template>
